import { Link } from 'react-router-dom';
import { Button } from '@usacow/ds';

export function NotFound() {
  return (
    <div className="notfound">
      <div className="t-eyebrow">404</div>
      <h1 className="notfound__h">This page doesn&apos;t exist.</h1>
      <p className="notfound__p">The link may be old, or the content was retired.</p>
      <Link to="/app">
        <Button variant="primary">Back to home</Button>
      </Link>
    </div>
  );
}
